/**
 * Guardarraíl del editor de recetas (tren "sigue" 2026-09-08) — el −20 de #7 fue
 * un dato que el editor aceptó sin decir nada ("Queso Oaxaca (k…" con la unidad
 * truncada y un campo de cantidad sin unidad). Helpers PUROS (vitest):
 *  - unidad completa y repetida como sufijo del campo ("0.0200 kg").
 *  - captura alterna en g/ml para insumos en kg/L (conversión visible; SIEMPRE se
 *    guarda en la unidad del insumo).
 *  - AVISO de sanidad (no bloqueo) al guardar: >1 kg / >1 L por unidad de platillo,
 *    o costo de receta por unidad > precio de venta del producto.
 */
export interface RecipeLineInfo {
  insumoName: string;
  unit: string;
  qty: number;
  /** costo por unidad del insumo (null = sin costo capturado). */
  cost: number | null;
}

/** Unidades "grandes": 1 de éstas por platillo ya es sospechoso. */
export function isBigUnit(unit: string): boolean {
  return /^(kg|l|lt|litro|litros)$/i.test((unit ?? '').trim());
}

/** Unidad alterna de captura (kg→g, L→ml); null si no aplica. */
export function altUnitOf(unit: string): 'g' | 'ml' | null {
  const u = (unit ?? '').trim().toLowerCase();
  if (u === 'kg') return 'g';
  if (u === 'l' || u === 'lt' || u === 'litro' || u === 'litros') return 'ml';
  return null;
}

/** 20 (g|ml) → 0.02 en la unidad base del insumo. */
export function altToBase(altValue: number): number {
  return Math.round((altValue / 1000 + Number.EPSILON) * 10000) / 10000;
}

/** Texto de conversión visible: "20 g = 0.020 kg". */
export function conversionLabel(altValue: number, unit: string): string {
  const alt = altUnitOf(unit);
  return alt ? `${altValue} ${alt} = ${altToBase(altValue).toFixed(3)} ${unit.trim().toLowerCase()}` : '';
}

/**
 * AVISOS de sanidad al guardar (no bloquean). El caso #7 textual: 20 kg por sopa.
 */
export function recipeWarnings(lines: RecipeLineInfo[], salePrice: number | null): string[] {
  const warns: string[] = [];
  for (const l of lines) {
    if (isBigUnit(l.unit) && l.qty > 1) {
      warns.push(`¿Seguro? ${l.qty} ${l.unit.trim().toLowerCase()} de ${l.insumoName} POR UNIDAD de platillo.`);
    }
  }
  const knownCosts = lines.filter((l) => l.cost != null && Number.isFinite(Number(l.cost)));
  if (knownCosts.length && salePrice != null && salePrice > 0) {
    const recipeCost = Math.round(knownCosts.reduce((s, l) => s + Number(l.cost) * l.qty, 0) * 100) / 100;
    if (recipeCost > salePrice) {
      warns.push(`El costo de la receta ($${recipeCost.toFixed(2)} por unidad) SUPERA el precio de venta ($${salePrice.toFixed(2)}).`);
    }
  }
  return warns;
}
